// react-redux imports
import { MouseEvent, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "app/store";

// common imports
import StandardButton from "common/components/styled-components/StandardButton";

// common imports
import FlexSpan from "common/components/styled-components/FlexSpan";
import Tooltip from "common/components/Tooltip";
import TooltipPopUp from "common/components/TooltipPopUp";
import { TooltipAction, TOOLTIP_ACTIONS } from "common/constants/tooltip";

// styled-components imports
import UserInputSection from "../styled-components/UserInputSection";
import WasteHeading from "./styled-components/WasteHeading";
import WasteIndication from "./styled-components/WasteIndication";
import WasteOptionGroup from "./styled-components/WasteOptionGroup";

import { SeparatedWaste, setSeparatedWaste } from "./householdHabitsSlice";
import { SEPARATED_WASTE_OPTIONS } from "../constants/householdHabits";
import PopUpContentGroup from "common/components/styled-components/PopUpContentGroup";
import PopUpTitle from "common/components/styled-components/PopUpTitle";
import PopUpParagraph from "common/components/styled-components/PopUpParagraph";

function StepThree() {
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);

  const dispatch = useDispatch();
  const upDesktopScreen = useSelector(
    (state: RootState) => state.app.upDesktopScreen
  );

  const separatedWaste = useSelector(
    (state: RootState) => state.calculator.householdHabits.separatedWaste
  );

  function handleWasteSelection(e: MouseEvent<HTMLButtonElement>) {
    e.preventDefault();
    const waste = e.currentTarget.value as keyof SeparatedWaste;
    dispatch(setSeparatedWaste({ waste, value: !separatedWaste[waste] }));
  }

  function handleTooltip(action: TooltipAction) {
    switch (action) {
      case TOOLTIP_ACTIONS.OPEN:
        return () => setIsTooltipOpen(true);

      case TOOLTIP_ACTIONS.CLOSE:
        return () => setIsTooltipOpen(false);

      case TOOLTIP_ACTIONS.TOGGLE:
        return () => setIsTooltipOpen(!isTooltipOpen);

      default:
        return () => undefined;
    }
  }

  return (
    <>
      <WasteHeading>
        <span>
          ¿Qué residuos separas del resto?{" "}
          <WasteIndication>
            (puedes seleccionar más de{" "}
            <FlexSpan>
              uno)&nbsp;
              <Tooltip
                onClick={handleTooltip(TOOLTIP_ACTIONS.TOGGLE)}
                size={upDesktopScreen ? undefined : 12}
              />
            </FlexSpan>
          </WasteIndication>
        </span>
        {isTooltipOpen && (
          <TooltipPopUp
            title="¿Qué residuos separas del resto?"
            handleClose={handleTooltip(TOOLTIP_ACTIONS.CLOSE)}
          >
            <PopUpContentGroup>
              <PopUpTitle>Vidrio</PopUpTitle>
              <PopUpParagraph>
                Tarros, botellas, recipientes o cualquier objeto que esté hecho
                con cristal.
              </PopUpParagraph>
            </PopUpContentGroup>
            <PopUpContentGroup>
              <PopUpTitle>Plástico</PopUpTitle>
              <PopUpParagraph>
                Envases de plástico, latas de bebidas y latas de conservas,
                tetrabricks, bandejas de porexpan, papel de aluminio, film
                transparente...
              </PopUpParagraph>
            </PopUpContentGroup>
            <PopUpContentGroup>
              <PopUpTitle>Papel y cartón</PopUpTitle>
              <PopUpParagraph>
                Folios, cajas de cartón, revistas, periódicos, bolsas de papel,
                cajas de cereales, cajas de zapatos, cartulinas.
              </PopUpParagraph>
            </PopUpContentGroup>
            <PopUpContentGroup>
              <PopUpTitle>Orgánico</PopUpTitle>
              <PopUpParagraph>
                Son residuos biodegradables de origen vegetal y/animal generados
                en el ámbito doméstico. En su mayoría serán restos de comida y
                poda del jardín.
              </PopUpParagraph>
            </PopUpContentGroup>
          </TooltipPopUp>
        )}
      </WasteHeading>
      <UserInputSection>
        <WasteOptionGroup>
          {SEPARATED_WASTE_OPTIONS.map((waste) => (
            <StandardButton
              key={`separated-waste__${waste.value}`}
              selected={separatedWaste[waste.value]}
              value={waste.value}
              onClick={handleWasteSelection}
            >
              {waste.label}
            </StandardButton>
          ))}
        </WasteOptionGroup>
      </UserInputSection>
    </>
  );
}

export default StepThree;
